import $ from 'jquery';

function kontingentChange() {
    const kontingent = $('select[name="kontingent"]').val();
    if (kontingent === '1') {
        $('#lastschriftFalse').prop("checked", true);
        $('.kostenpflichtig').hide();
        $('.kostenlos').show();
    } else {
        $('.kostenpflichtig').show();
        $('.kostenlos').hide();
    }
}

window.addEventListener('DOMContentLoaded', function () {
    kontingentChange();
    const select = $('select[name="kontingent"]');
    $(select).change(kontingentChange);
});